import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import useLang from '../../i18n';
import { Toaster } from 'react-hot-toast';



export default function AppLayout() {
  const { lang, t } = useLang();
  const PAGE_TITLES = {
    '/dashboard':t('dashboard'), '/sales':t('sales'), '/sales/new':t('newSale'),
    '/invoices':t('invoices'), '/customers':t('customers'), '/purchases':t('purchases'),
    '/suppliers':t('suppliers'), '/products':t('products'), '/inventory':t('inventoryReport'),
    '/accounts':t('accounts'), '/journals':t('journals'), '/trial-balance':t('trialBalance'),
    '/income':t('incomeStatement'), '/balance-sheet':t('balanceSheet'),
    '/cashbox':t('cashbox'), '/bank':t('bank'), '/expenses':t('expenses'),
    '/revenues':t('revenues'), '/partners':t('partners'),
    '/branches':t('branches'), '/users':t('users'), '/budget':t('budget'),
    '/assets':t('assets'), '/fiscal-years':t('fiscalYears'),
    '/audit':t('audit'), '/settings':t('settings'), '/reports':t('reports'),
  };
  const { pathname } = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const title = Object.entries(PAGE_TITLES)
    .find(([k]) => pathname === k || pathname.startsWith(k + '/'))?.[1] || t('companyName');

  return (
    <div className="flex min-h-screen bg-gray-50" dir={lang === "en" ? "ltr" : "rtl"}>
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <div className={`fixed top-0 h-screen z-50 transition-transform duration-300
        ${lang === 'en' ? 'left-0' : 'right-0'}
        ${sidebarOpen ? 'translate-x-0' : lang === 'en' ? '-translate-x-full lg:translate-x-0' : 'translate-x-full lg:translate-x-0'}`}>
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </div>

      {/* Main */}
      <div className={`flex-1 flex flex-col min-h-screen overflow-x-hidden ${lang === "en" ? "lg:ml-64" : "lg:mr-64"}`}>
        <Topbar title={title} onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 p-4 lg:p-6">
          <Outlet />
        </main>
      </div>

      <Toaster position="bottom-left" toastOptions={{
        duration: 3000,
        style: { direction:'rtl', fontFamily:'Vazirmatn,sans-serif', fontSize:'13px', borderRadius:'12px' },
      }} />
    </div>
  );
}
